import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { Link } from 'react-router-dom';
import { deviceMax } from 'utils/styles/breakpoints';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const Wrapper = styled.div`
  position: relative;
  ${FLEX_CONTAINER.FlexCenterColumn}
  background-repeat: no-repeat;
`;

export const CheckboxLabel = styled.label`
  ${FLEX_CONTAINER.FlexRow}
`;

export const LoginFormContainer = styled.div`
  background: linear-gradient(
    155.67deg,
    rgba(255, 255, 255, 0.59) -7.08%,
    rgba(255, 255, 255, 0.13) 110.41%
  );
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  width: 450px;
  padding: 10px;
  margin-top: 160px;
  margin-bottom: 100px;

  @media only screen and ${deviceMax.desktop} {
    width: 400px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 290px;
  }
`;

export const TextLogin = styled.div`
  ${FONTS.font24}
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontBold}
  text-align: center;
  text-transform: capitalize;
  margin-top: 20px;
  position: relative;

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font20}
  }
`;

export const CloseIcon = styled.img`
  @media only screen and ${deviceMax.mobileL} {
    width: 12px;
  }
`;

export const Form = styled.form`
  padding: 20px;
  position: relative;
`;

export const RememberAndForgotSection = styled.div`
  ${FLEX_CONTAINER.FlexEndRow};
  width: 100%;
  margin-top: 30px;
`;

export const CheckboxInput = styled.input`
  width: 20px;
  height: 20px;
  border: 1px solid ${COLORS.mainColor};
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
  accent-color: ${COLORS.mainColor};

  &:checked {
    -webkit-appearance: checkbox;
  }
`;

export const RememberText = styled.div`
  ${FONTS.font16}
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontRegular}
  padding-left: 16px;
  cursor: pointer;

  @media only screen and ${deviceMax.mobileL} {
    padding-left: 6px;
    ${FONTS.font12}
  }
`;

export const ForgotText = styled.div`
  ${FONTS.font16}
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontMedium}

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font12}
  }
`;

export const AuthenticationLink = styled(Link)`
  ${FONTS.font16}
  ${FONT_FAMILY.FontBold}
  color: ${COLORS.mainColor};

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font12}
  }
`;

export const SignUpText = styled.span`
  padding-right: 6px;
`;

export const TextBold = styled.div`
  ${FONTS.font16}
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontRegular}
  text-align: center;

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font12}
  }
`;

export const SuggestionBlockWithIcons = styled.div`
  margin-bottom: 20px;
  padding: 0px 20px;

  @media only screen and ${deviceMax.desktop} {
    margin-top: 20px;
  }
`;

export const StyledButtonContainer = styled.div`
  margin-top: 30px;
`;

export const SuggestionText = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow}
  width: 100%;
  color: ${COLORS.mainColor};

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font14}
  }
`;

export const PasswordVisibleIcon = styled.img`
  position: absolute;
  right: 0px;
  top: 15px;
  width: 26px;
  cursor: pointer;

  @media only screen and ${deviceMax.desktop} {
    width: 20px;
    right: 0px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 16px;
  }
`;

export const LoginErrorMessage = styled.p`
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font12};
  color: ${COLORS.red};
  padding-top: 8px;
  height: 14px;
`;
export const CloseIconLink = styled(Link)`
  position: absolute;
  top: 20px;
  right: 30px;

  @media only screen and ${deviceMax.desktop} {
    width: 14px;
    right: 20px;
    top: 20px;
  }
`;
